<template>
    <svg version="1.1" class="3_dots" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 35 35" width="8px" height="8px" style="enable-background:new 0 0 35 35;" xml:space="preserve">
        <path fill="currentColor" d="M17.5,17.1c-3.6,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4,6.4,2.9,6.4,6.4-2.9,6.4-6.4,6.4ZM25.3,30.6c-3.6,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4,6.4,2.9,6.4,6.4-2.9,6.4-6.4,6.4ZM9.8,30.6c-3.6,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4,6.4,2.9,6.4,6.4-2.9,6.4-6.4,6.4Z"/>
    </svg>
</template>
